import { render, staticRenderFns } from "./revocation-dialog.vue?vue&type=template&id=562097f8&"
import script from "./revocation-dialog.vue?vue&type=script&lang=js&"
export * from "./revocation-dialog.vue?vue&type=script&lang=js&"
import style0 from "./revocation-dialog.vue?vue&type=style&index=0&id=562097f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports